// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2Lo9r","label":"style_label__31EXW","switch":"style_switch__rVjL5","slider":"style_slider__29xw7"};